export const removeSpinner = () => {
  const spinner = document.getElementById('spinner-div');
  if (spinner && spinner.parentNode) {
    spinner.parentNode.removeChild(spinner);
  }
};
